import { Component, OnInit, forwardRef } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { Subject, debounceTime, distinctUntilChanged, switchMap } from 'rxjs';
import { EmailService } from '../../../core/services/email.service';
import { EmailListItem } from '../../../core/models/app.models';

interface EmailOption extends EmailListItem { label: string; }

/**
 * Výběr e-mailu hledáním (předmět / odesílatel) s bindingem na emailId
 * (ControlValueAccessor). Vzor podle app-transfer-select — lazy serverový filtr
 * přes EmailService.getList(search).
 */
@Component({
  selector: 'app-email-select',
  template: `
    <p-dropdown [options]="emails" [(ngModel)]="value" [showClear]="true" [filter]="true" [lazy]="true"
                (onFilter)="onSearch($event)" placeholder="Hledejte e-mail (předmět / odesílatel)"
                [style]="{'width':'100%'}" appendTo="body" [loading]="loading"
                (onChange)="onChanged($event.value)" optionLabel="label" optionValue="id">
      <ng-template let-e pTemplate="item">
        <div class="flex flex-column py-1">
          <span class="font-bold">{{ e.subject || '(bez předmětu)' }}</span>
          <small class="text-400">{{ e.fromAddress }} · {{ e.date | date:'dd.MM.yyyy' }}</small>
        </div>
      </ng-template>
    </p-dropdown>
  `,
  providers: [{ provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => EmailSelectComponent), multi: true }]
})
export class EmailSelectComponent implements OnInit, ControlValueAccessor {
  emails: EmailOption[] = [];
  loading = false;
  private searchSubject = new Subject<string>();
  _value: any;

  constructor(private emailService: EmailService) {}

  ngOnInit() {
    this.loadInitial();
    this.searchSubject.pipe(
      debounceTime(300), distinctUntilChanged(),
      switchMap(q => { this.loading = true; return this.emailService.getList(1, 20, q && q.length >= 2 ? q : undefined); })
    ).subscribe(res => { this.emails = res.data.map(e => this.toOption(e)); this.loading = false; });
  }

  private loadInitial() {
    this.loading = true;
    this.emailService.getList(1, 20).subscribe(res => { this.emails = res.data.map(e => this.toOption(e)); this.loading = false; });
  }

  private toOption(e: EmailListItem): EmailOption {
    return { ...e, label: `${e.subject || '(bez předmětu)'} · ${e.fromAddress ?? ''}` };
  }

  onSearch(event: any) { this.searchSubject.next(event.filter); }

  get value() { return this._value; }
  set value(v: any) { if (v !== this._value) { this._value = v; this.onChange(v); } }
  onChange: any = () => {};
  onTouched: any = () => {};
  writeValue(v: any): void { this._value = v; }
  registerOnChange(fn: any): void { this.onChange = fn; }
  registerOnTouched(fn: any): void { this.onTouched = fn; }
  onChanged(val: any) { this.value = val; }
}
